/**************************************************
 * Nombre:       Tarjeta_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Contacto = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.icon} width={'70%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 9, sm: 12, md: 9}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontSize: sCell ? 20 : 26,
                        fontFamily: NEGRITA,
                        fontWeight: 600,
                        lineHeight: 1.1
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, height: 50, lineHeight: 1.2}}>{item.descripcion}</Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Contacto